// Configuración de APIs para IQsit Demos
// Todo pasa por N8N - no hay conexiones directas al RAG

const N8N_BASE_URL = 'https://automation.iqsit.com'

// URLs de webhooks de N8N - URLs exactas según los workflows
export const N8N_WEBHOOKS = {
  PDF_PROCESSING: `${N8N_BASE_URL}/webhook/process-pdf`,
  CONCILIATION: `${N8N_BASE_URL}/webhook/start-conciliation`,
  CHAT: `${N8N_BASE_URL}/webhook/chat-simple`, // URL que usa el chat actualmente
  TEST_CONNECTION: `${N8N_BASE_URL}/webhook/test`
}

// Configuración para requests
export const REQUEST_CONFIG = {
  timeout: 30000, // 30 segundos
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  },
  corsEnabled: true
}

// Helper para crear FormData requests
export const createFormDataRequest = (url, formData) => {
  return fetch(url, {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      // No incluir Content-Type para FormData, el navegador lo establece automáticamente
    },
    body: formData,
    mode: 'cors'
  })
}

// Helper para crear JSON requests
export const createJSONRequest = (url, data) => {
  return fetch(url, {
    method: 'POST',
    headers: REQUEST_CONFIG.headers,
    body: JSON.stringify(data),
    mode: 'cors'
  })
}

// Helper para manejar respuestas de API
export const handleAPIResponse = async (response) => {
  // Log the response for debugging
  console.log(`📡 Response Status: ${response.status} ${response.statusText}`)
  console.log(`📡 Response Headers:`, Object.fromEntries(response.headers))
  
  if (!response.ok) {
    let errorText = ''
    try {
      errorText = await response.text()
    } catch (e) {
      errorText = `Failed to read error response: ${e.message}`
    }
    throw new Error(`API Error ${response.status}: ${errorText || 'No error message available'}`)
  }
  
  // Get response text first to handle empty responses
  const responseText = await response.text()
  console.log(`📡 Raw Response Text:`, responseText)
  
  if (!responseText || responseText.trim() === '') {
    throw new Error('Empty response from server')
  }
  
  const contentType = response.headers.get('content-type')
  if (contentType && contentType.includes('application/json')) {
    try {
      return JSON.parse(responseText)
    } catch (parseError) {
      throw new Error(`Invalid JSON response: ${parseError.message}. Raw response: ${responseText}`)
    }
  } else {
    return responseText
  }
}

// Logger para debugging
export const apiLogger = {
  request: (url, options) => {
    console.log(`🚀 API Request: ${options?.method || 'GET'} ${url}`, options)
  },
  response: (url, data) => {
    console.log(`✅ API Response: ${url}`, data)
  },
  error: (url, error) => {
    console.error(`❌ API Error: ${url}`, error)
  }
}

export default {
  N8N_WEBHOOKS,
  REQUEST_CONFIG,
  createFormDataRequest,
  createJSONRequest,
  handleAPIResponse,
  apiLogger
} 